import { render } from "./NavbarShorterComp.vue?vue&type=template&id=10835ed0"
import script from "./NavbarShorterComp.vue?vue&type=script&lang=js"
export * from "./NavbarShorterComp.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__